import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { HERO_BANNERS } from '../mock/mockData';

const HeroCarousel = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % HERO_BANNERS.length), 5000);
    return () => clearInterval(t);
  }, []);

  const go = (n) => setIdx((idx + n + HERO_BANNERS.length) % HERO_BANNERS.length);

  return (
    <section className="relative h-[420px] md:h-[560px] overflow-hidden bg-[#F3EFE8]">
      {HERO_BANNERS.map((b, i) => (
        <div
          key={b.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${i === idx ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        >
          <img src={b.image} alt={b.title} className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1F2A44]/60 via-[#1F2A44]/20 to-transparent" />
          <div className="relative h-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col justify-center text-[#FAF7F2]">
            <span className="inline-block w-fit px-3 py-1 bg-[#E8B530] text-[#1F2A44] text-[11px] font-bold uppercase tracking-wider rounded-sm mb-4 animate-in fade-in slide-in-from-bottom-2 duration-700">FOSEN Premium</span>
            <h1 className="font-serif text-4xl md:text-6xl font-bold leading-tight max-w-xl tracking-tight">{b.title}</h1>
            <p className="mt-3 text-base md:text-lg max-w-md text-[#FAF7F2]/90">{b.subtitle}</p>
            <Link
              to={b.link}
              className="mt-6 inline-block w-fit bg-[#E8B530] hover:bg-[#D4A220] text-[#1F2A44] font-semibold px-7 py-3 rounded-sm uppercase tracking-wider text-sm transition-colors"
            >
              {b.cta}
            </Link>
          </div>
        </div>
      ))}

      <button onClick={() => go(-1)} className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#FAF7F2]/80 hover:bg-[#E8B530] text-[#1F2A44] flex items-center justify-center transition-colors backdrop-blur">
        <ChevronLeft size={20} />
      </button>
      <button onClick={() => go(1)} className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#FAF7F2]/80 hover:bg-[#E8B530] text-[#1F2A44] flex items-center justify-center transition-colors backdrop-blur">
        <ChevronRight size={20} />
      </button>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-2">
        {HERO_BANNERS.map((_, i) => (
          <button
            key={i}
            onClick={() => setIdx(i)}
            aria-label={`Slide ${i+1}`}
            className={`h-1.5 rounded-full transition-all duration-300 ${i === idx ? 'w-8 bg-[#E8B530]' : 'w-2 bg-[#FAF7F2]/60'}`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroCarousel;
